import React from 'react'
import { FieldProps } from '../FormDuuf'

// Libraries
import ReCAPTCHA from 'react-google-recaptcha'

// Formik
import { useFormikContext, FormikContextType } from 'formik'

// Elements
import Label from '../elements/Label'
import Error from '../elements/Error'
import useFormDuuf from '../useFormDuuf'

const CaptchaField: React.FC<FieldProps> = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { handleChange }: FormikContextType<{}> = useFormikContext<{}>()
  const { captchaSiteKey, setCaptchaFilled } = useFormDuuf()

  if (!captchaSiteKey) {
    return null
  }

  const handleCaptcha = (value: string) => {
    handleChange({
      target: {
        name: 'g-recaptcha-response',
        value
      }
    })

    setCaptchaFilled(!!value)
  }

  return (
    <div className={`form-duuf-group form-duuf-group-${data.type.toLowerCase()}`}>
      <Label fieldId={fieldId} data={data} />
      <Error fieldId={fieldId} data={data} hasError={hasError} formik={formik} />
      <ReCAPTCHA
        sitekey={captchaSiteKey}
        onChange={handleCaptcha}
        onExpired={() => {
          handleCaptcha('')
        }}
        onErrored={() => {
          handleCaptcha('')
        }}
      />
    </div>
  )
}

export default CaptchaField
